module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i69US"))).then(() => parcelRequire('1iHdE'));